import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { matchPath } from 'react-router';

import moment from 'config/Moment';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as JourneysActions, Selectors as JourneysSelectors } from 'store/ducks/journeys';

import { Validate } from 'common';
import { Page, Panel, Button, Loading } from 'components';
import { Form } from 'pages/Admin/Journeys/components';

class Edit extends Component {
  state = {
    data: {
      name: '',
      available_from: '',
      available_until: '',
      description: '',
    },
    errors: {},
  };

  componentDidMount() {
    const { getJourneyRequest } = this.props;

    getJourneyRequest(this.handleGetID());
  }

  componentDidUpdate(oldProps) {
    const { data } = this.state;
    const { journey } = this.props;

    if (oldProps.journey.loading && !journey.loading) {
      this.setState({
        data: {
          ...data,
          name: journey.data.attributes.name,
          description: journey.data.attributes.description,
          available_from: journey.data.attributes['available-from'],
          available_until: journey.data.attributes['available-until'],
          east_face_quiz: journey.data.attributes.east_face_quiz,
          west_face_quiz: journey.data.attributes.west_face_quiz,
          north_face_quiz: journey.data.attributes.north_face_quiz,
          south_face_quiz: journey.data.attributes.south_face_quiz,
        },
      });
    }
  }

  handleGetID = () => {
    const match = matchPath(this.props.location.pathname, { path: '/admin/journeys/:id/edit' });
    return match.params.id;
  };

  handleChange = data => {
    this.handleValidate();
    this.setState({ data });
  };

  handleValidate = () => {
    const { data } = this.state;

    const rules = {
      name: {
        required: true,
      },

      description: {
        required: true,
      },

      available_from: {
        required: true,
      },

      available_until: {
        required: true,
      },

      east_face_quiz: {
        required: true,
      },

      west_face_quiz: {
        required: true,
      },

      south_face_quiz: {
        required: true,
      },

      north_face_quiz: {
        required: true,
      },
    };

    const validate = Validate(data, rules);
    this.setState({ errors: validate.errors });

    return validate.valid;
  };

  handleSubmit = e => {
    e.preventDefault();

    if (!this.handleValidate()) return null;

    const { data } = this.state;

    const { updateJourneyRequest } = this.props;

    updateJourneyRequest(this.handleGetID(), {
      interview: {
        id: data.couse.id,
        course: data.course,
        course_class: data.course_class,
        calculated_at: moment(data.calculated_at).format('YYYY-MM-DD HH:mm'),
      },
    });
  };

  render() {
    const { data, errors } = this.state;
    const { update, journey } = this.props;

    return (
      <Page>
        <div className="row align-items-center">
          <div className="col-6">
            <Page.Title>Editar Jornada</Page.Title>
          </div>

          <div className="col-6 text-right">
            <Button type="success" onClick={this.handleSubmit} disabled={update.loading || journey.loading}>
              {update.loading ? <Loading type="btn" size="small" text="Salvando..." /> : 'Salvar'}
            </Button>

            <Link to="/admin/journeys" className="btn btn-danger m-l-10">
              Cancelar
            </Link>
          </div>
        </div>

        <Panel>
          <Form data={data} errors={errors} onChange={this.handleChange} onSubmit={this.handleSubmit} />
        </Panel>
      </Page>
    );
  }
}

const mapState = state => ({
  journey: {
    ...state.journeys.journey,
    data: JourneysSelectors.detail(state.journeys.journey.data),
  },
  update: state.journeys.update,
});

const mapActions = dispatch => bindActionCreators(JourneysActions, dispatch);

export default connect(
  mapState,
  mapActions,
)(Edit);



// WEBPACK FOOTER //
// ./src/pages/Admin/Journeys/Edit/index.js